module.exports = __webpack_public_path__ + "static/img/cabecera4.a2357b43.png";